'use strict';

import http from '@/utils/http';

export default {
  pageUrl: '/issmart-user/contact/page',
  importContactUrl: '/issmart-user/contact/contactUpload',
  importActionUrl: '/issmart-user/contactActionInfo/contactActionUpload',
  getPage(code, params) {
    return http.get('/issmart-user/contact/page', { params, code });
  },
  add(code, data) {
    return http.post('/issmart-user/contact', data, { code });
  },
  update(code, data) {
    return http.put('/issmart-user/contact', data, { code });
  },
  delete(code, params) {
    return http.delete('/issmart-user/contact/single', { params, code });
  },
  downloadContactTemplate(code) {
    return http.get('/issmart-user/contact/contactTemplate', {
      responseType: 'blob',
      code,
    });
  },
  downloadActionTemplate(code) {
    return http.get('/issmart-user/contactActionInfo/contactActionTemplate', {
      responseType: 'blob',
      code,
    });
  },
  export(code, params) {
    return http.get('/issmart-user/contact/contactExport', {
      responseType: 'blob',
      params,
      code,
    });
  },
};
